/* TEST parity: measurement and identity run under Shopify Not-required mode.
 * Actual Shopify/native consent is observed for diagnostics, never fabricated. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (root && root.document) {
    try { api.install(root, root.document, { measurementMode: api.DEPLOYMENT_MODE }); } catch (_) { /* Contain synchronous adapter failures. */ }
  }
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  var VERSION = '2026-09-08-v3';
  // Explicit delivery choice; install() callers without this option remain strict.
  var DEPLOYMENT_MODE = 'formal_pixel_parity';
  var MEASUREMENT = 'G-CFN5E3LE85';
  var CONTAINER = 'GTM-WZ8FZ5W4';
  var LAYER = 'dataLayer';
  var READY_CALLBACK = '__yarboGa4TestTagReady';
  var BRIDGE = 'yarbo_test_ga_identity_v2';
  var LEGACY_BRIDGE = 'yarbo_test_ga_identity_v1';
  var HOSTS = ['www.yarbo.com', 'yarbo.com'];
  var EVENTS = ['page_view', 'view_item', 'view_item_list', 'select_item', 'add_to_cart', 'remove_from_cart', 'view_cart'];
  // Exact attribution allowlist, not arbitrary query/cookie/token passthrough.
  var CLICK_QUERIES = ['gclid', 'gbraid', 'wbraid', 'dclid', 'gclsrc', 'gad_source', 'gad_campaignid', 'msclkid', 'fbclid', 'ttclid'];
  var QUERIES = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_source_platform', 'utm_content', 'utm_term', 'variant'];

  function text(value, limit) {
    var result = String(value == null ? '' : value).replace(/[\u0000-\u001f<>]/g, '').slice(0, limit || 100);
    return /[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}/.test(result) ? '' : result;
  }
  function cleanUrl(raw, base, limit) {
    try {
      var url = new URL(String(raw || ''), base || 'https://www.yarbo.com');
      if (!/^https?:$/.test(url.protocol) || url.username || url.password) return '';
      if (!HOSTS.includes(url.hostname)) return url.origin + '/';
      // GA4 bounds apply to the encoded URL: page_location 1000, page_referrer 420.
      var maxLength = limit === 420 ? 420 : 1000;
      var pathname = decodeURIComponent(url.pathname);
      // Account, payment, and order status paths can contain personal or bearer data.
      if (/(^|\/)(account|accounts|customer_authentication|checkouts?|orders|thank_you)(\/|$)/i.test(pathname)) {
        return url.origin + '/';
      }
      if (/@|[\u0000-\u001f]/.test(pathname)) return url.origin + '/';
      var safe = new URL(url.origin + url.pathname);
      if (safe.href.length > maxLength) safe = new URL(url.origin + '/');
      function addQuery(key, isClickId) {
        var value = url.searchParams.get(key);
        if (!value || /@|[\u0000-\u001f\u007f<>]|\b(?:token|password|secret|email)=/i.test(value)) return;
        if (isClickId ? !/^[A-Za-z0-9._~-]+$/.test(value) : value.length > 150) return;
        safe.searchParams.set(key, value);
        // Never cut an opaque click ID (or a percent escape) to fit the budget.
        // An individually overlong ID cannot be represented here and is omitted.
        if (safe.href.length > maxLength) safe.searchParams.delete(key);
      }
      CLICK_QUERIES.forEach(function (key) { addQuery(key, true); });
      QUERIES.forEach(function (key) { addQuery(key, false); });
      return safe.href;
    } catch (_) { return ''; }
  }
  function item(raw) {
    if (!raw || !/^[1-9]\d{0,31}$/.test(String(raw.item_id || ''))) return null;
    var price = Number(raw.price), quantity = Number(raw.quantity);
    if (!Number.isFinite(price) || price < 0 || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 10000) return null;
    var name = text(raw.item_name);
    if (!name) return null;
    return { item_id: String(raw.item_id), item_name: name, item_variant: text(raw.item_variant), price: Math.round(price * 100) / 100, quantity: quantity };
  }
  function cartSnapshot(raw) {
    if (!raw || raw.errors || raw.status || !/^[A-Z]{3}$/.test(raw.currency || '') || !Array.isArray(raw.items) || raw.items.length > 100) return null;
    var items = raw.items.map(function (line) {
      if (!Number.isSafeInteger(line.final_price) || line.final_price < 0) return null;
      return item({ item_id: String(line.variant_id || ''), item_name: line.product_title || line.title, item_variant: line.variant_title, price: line.final_price / 100, quantity: line.quantity });
    });
    if (items.some(function (entry) { return !entry; })) return null;
    var count = items.reduce(function (sum, entry) { return sum + entry.quantity; }, 0);
    if (!Number.isSafeInteger(raw.item_count) || raw.item_count !== count) return null;
    return { currency: raw.currency, items: items };
  }
  function aggregate(items) {
    var map = new Map();
    items.forEach(function (entry) {
      // Variant identity, not cart line keys: properties/discount changes are not new products.
      var previous = map.get(entry.item_id);
      if (previous) {
        previous.quantity += entry.quantity;
        if (previous.price !== entry.price) previous.ambiguous_price = true;
      }
      else map.set(entry.item_id, Object.assign({}, entry));
    });
    return map;
  }
  function cartDiff(before, after) {
    if (!before || !after || before.currency !== after.currency) return [];
    var a = aggregate(before.items), b = aggregate(after.items), added = [], removed = [];
    new Set(Array.from(a.keys()).concat(Array.from(b.keys()))).forEach(function (id) {
      // Multiple discounts for one variant: do not invent the unit price of a net change.
      if ((a.get(id) && a.get(id).ambiguous_price) || (b.get(id) && b.get(id).ambiguous_price)) return;
      var delta = (b.get(id) || { quantity: 0 }).quantity - (a.get(id) || { quantity: 0 }).quantity;
      if (delta > 0) added.push(Object.assign({}, b.get(id), { quantity: delta }));
      if (delta < 0) removed.push(Object.assign({}, a.get(id), { quantity: -delta }));
    });
    return [{ name: 'add_to_cart', items: added }, { name: 'remove_from_cart', items: removed }].filter(function (event) { return event.items.length; });
  }
  function validIdentity(cid, sid, now) {
    var number = Number(sid);
    return typeof cid === 'string' && /^\d{1,20}\.\d{1,20}$/.test(cid) && /^[1-9]\d{0,15}$/.test(String(sid)) &&
      Number.isSafeInteger(number) && number * 1000 <= now + 60000 && now - number * 1000 <= 86400000;
  }
  function validSessionNumber(value) {
    var number = Number(value);
    return /^[1-9]\d{0,9}$/.test(String(value)) && Number.isSafeInteger(number);
  }
  function validUserId(value) {
    return value == null || (typeof value === 'string' && /^shp_[a-f0-9]{64}$/.test(value));
  }
  function install(win, doc, options) {
    options = options || {};
    var mode = options.measurementMode === undefined ? 'strict' : options.measurementMode;
    if (mode !== 'strict' && mode !== 'native_inherit' && mode !== 'formal_pixel_parity') return null;
    if (!HOSTS.includes(win.location.hostname) || win.location.protocol !== 'https:' || win.top !== win || win.__yarboGa4TestInstalled) return null;
    var configNode = doc.getElementById('yarbo-ga4-test-config');
    if (!configNode) return null;
    var config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return null; }
    // Accept only the exact installed v1 snippet or the v2 schema. The v1 layer
    // name is compatibility metadata, NEVER a queue to create, read or replay.
    var legacyConfig = config.version === '2026-09-08-v1' && config.data_layer === 'yarboTestDataLayer';
    var currentConfig = (config.version === VERSION || config.version === '2026-09-08-v2') && config.data_layer === LAYER;
    if ((!legacyConfig && !currentConfig) || config.enabled !== true || config.measurement_id !== MEASUREMENT || config.container_id !== CONTAINER) return null;
    if ((win[LAYER] !== undefined && !Array.isArray(win[LAYER])) || win[READY_CALLBACK] !== undefined) return null;
    if (!/^[A-Z]{3}$/.test(config.currency || '')) return null;
    if (!validUserId(config.user_id)) return null;
    var cartUrl;
    try {
      cartUrl = new URL(config.cart_url, win.location.origin);
      if (cartUrl.origin !== win.location.origin || !/^\/(?:[a-z]{2}(?:-[a-zA-Z]{2})?\/)?cart\.js$/.test(cartUrl.pathname) || cartUrl.search || cartUrl.hash) return null;
    } catch (_) { return null; }
    var status = { version: VERSION, config_version: config.version, data_layer: LAYER, state: 'waiting_for_privacy', measurement_mode: mode, measurement_allowed: false, identity_allowed: false, native_analytics_allowed: false, identity_epoch: 0, config_epoch: 0, consent_epoch: 1, analytics_allowed: false, gtm_requested: false, google_tag_configured: false, google_tag_ready: false, reload_required: false, cart_adapter: false, events_queued: 0, pending_events: 0, identity_cookie_written: false, last_skip: '' };
    win.__yarboGa4TestInstalled = true;
    win.__yarboGa4TestStatus = status; // No raw IDs, tokens, order/customer data, or credentials.
    var initiallyDisabled = win['ga-disable-' + MEASUREMENT] === true;
    if (mode === 'strict' && !initiallyDisabled) win['ga-disable-' + MEASUREMENT] = true;
    var allowed = false, epoch = 1, layer, started = false, configured = false, configEpoch = 0, configInvalidated = false;
    var pendingEvents = [], initialPageSent = false, initialProductSent = false, baseline = null, chain = Promise.resolve();
    var identityPending = false, identityGeneration = 0, lastIdentityAttempt = 0, identityAttempts = 0, unsubscribed = null, lastCartRead = 0;
    var collectionObserver = null, seenCollection = new Set(), cartVisible = false;
    function now() { return options.now ? options.now() : Date.now(); }
    function privacyAllows() {
      try {
        var privacy = win.Shopify && win.Shopify.customerPrivacy;
        return !!privacy && privacy.analyticsProcessingAllowed() === true && privacy.saleOfDataAllowed() === true;
      } catch (_) { return false; }
    }
    function identityCurrent() {
      return !initiallyDisabled && win['ga-disable-' + MEASUREMENT] !== true &&
        (mode === 'formal_pixel_parity' ||
          (allowed && privacyAllows() && status.native_analytics_allowed === true));
    }
    function current() {
      return !initiallyDisabled && win['ga-disable-' + MEASUREMENT] !== true &&
        (mode === 'native_inherit' || mode === 'formal_pixel_parity' || (allowed && privacyAllows()));
    }
    function context() {
      var value = { page_location: cleanUrl(win.location.href), page_referrer: doc.referrer ? cleanUrl(doc.referrer, undefined, 420) : '', page_title: text(doc.title, 150), context_source: 'yarbo_theme_test_v3' };
      if (config.user_id) value.user_id = config.user_id;
      return value;
    }
    function clearBridge() {
      doc.cookie = BRIDGE + '=; Max-Age=0; Path=/; Domain=yarbo.com; Secure; SameSite=Lax';
      doc.cookie = LEGACY_BRIDGE + '=; Max-Age=0; Path=/; Domain=yarbo.com; Secure; SameSite=Lax';
      status.identity_cookie_written = false;
    }
    function invalidateIdentity() {
      identityGeneration += 1; status.identity_epoch = identityGeneration;
      baseline = null; lastIdentityAttempt = 0; identityAttempts = 0;
    }
    function command() { layer.push(arguments); }
    function tagReady() { return current() && configured && status.google_tag_ready && !configInvalidated && win['ga-disable-' + MEASUREMENT] !== true; }
    function pushTest(event, payload) {
      try {
        // DLV v2 merges objects. Clear only our namespace, never production ecommerce.
        layer.push({ yarbo_test: null });
        layer.push({ event: event, yarbo_test: payload });
        return true;
      } catch (_) { status.last_skip = 'data_layer_push_failed'; return false; }
    }
    function getField(field) {
      return new Promise(function (resolve) {
        var completed = false;
        var timer = win.setTimeout(function () { if (!completed) { completed = true; resolve(null); } }, 1500);
        command('get', MEASUREMENT, field, function (value) {
          if (completed) return;
          completed = true; win.clearTimeout(timer); resolve(value);
        });
      });
    }
    async function refreshIdentity() {
      if (!identityCurrent() || !tagReady() || !initialPageSent || !layer || identityPending || identityAttempts >= 60 || now() - lastIdentityAttempt < 3000) return;
      identityPending = true; lastIdentityAttempt = now(); identityAttempts += 1;
      var generation = identityGeneration;
      try {
        var values = await Promise.all([getField('client_id'), getField('session_id'), getField('session_number')]);
        if (!identityCurrent() || !tagReady() || identityGeneration !== generation ||
            !validIdentity(values[0], values[1], now()) || !validSessionNumber(values[2])) return;
        var bridge = { v: 2, measurement_id: MEASUREMENT, client_id: values[0], session_id: String(values[1]),
          session_number: Number(values[2]), observed_at: now() };
        if (config.user_id) bridge.user_id = config.user_id;
        doc.cookie = BRIDGE + '=' + encodeURIComponent(JSON.stringify(bridge)) + '; Max-Age=1800; Path=/; Domain=yarbo.com; Secure; SameSite=Lax';
        status.identity_cookie_written = true;
      } catch (_) { status.last_skip = 'identity_unavailable'; }
      finally { identityPending = false; }
    }
    function deliver(payload) {
      if (!tagReady() || payload.consent_epoch !== epoch || status.events_queued >= 500) return false;
      if (!pushTest('yarbo_test_event', payload)) return false;
      status.events_queued += 1;
      if (payload.ga_event_name === 'page_view') initialPageSent = true;
      if (payload.ga_event_name === 'view_item') initialProductSent = true;
      return true;
    }
    function flushPending(generation) {
      if (!tagReady() || generation !== epoch) return;
      var queued = pendingEvents;
      pendingEvents = []; status.pending_events = 0;
      queued.forEach(deliver);
      void refreshIdentity();
    }
    function scheduleIdentity(generation) {
      [1500, 5000, 10000].forEach(function (delay) {
        win.setTimeout(function () { if (generation === epoch) void refreshIdentity(); }, delay);
      });
    }
    function acknowledgeTag(receipt) {
      if (!receipt || !started || configInvalidated ||
          receipt.version !== VERSION || receipt.measurement_id !== MEASUREMENT ||
          receipt.container_id !== CONTAINER || receipt.cookie_prefix !== 'yarbotest' ||
          typeof receipt.consent_epoch !== 'number' || receipt.consent_epoch !== configEpoch ||
          typeof receipt.native_analytics_allowed !== 'boolean') return false;
      if (!configured && (!current() || win['ga-disable-' + MEASUREMENT] === true ||
          (mode === 'strict' && receipt.consent_epoch !== epoch))) return false;
      // This read-only signal inherits the Google API's actual semantics. It does
      // not manufacture defaults or prove that an unset consent value is denied.
      var nativeChanged = status.native_analytics_allowed !== receipt.native_analytics_allowed;
      status.native_analytics_allowed = receipt.native_analytics_allowed;
      if (nativeChanged) {
        invalidateIdentity();
        if (!status.native_analytics_allowed && mode !== 'formal_pixel_parity') clearBridge();
      }
      status.identity_allowed = identityCurrent();
      if (configured) {
        if (nativeChanged && identityCurrent()) {
          void enqueueCart(false, config.page_type === 'cart');
          void refreshIdentity(); scheduleIdentity(epoch);
        }
        return true; // Consent observation can change; config/page_view do not repeat.
      }
      configured = true;
      status.google_tag_configured = true; status.google_tag_ready = true;
      status.state = 'test_tag_configured'; // GTM sequence acknowledgement, NOT GA receipt.
      var generation = epoch;
      // Yield until the successful cleanup tag finishes; time alone never unlocks.
      win.setTimeout(function () { flushPending(generation); }, 0);
      scheduleIdentity(generation);
      if (identityCurrent()) void enqueueCart(false, config.page_type === 'cart');
      return true;
    }
    win[READY_CALLBACK] = acknowledgeTag;
    function emit(name, items, extras, currency) {
      if (!current() || !layer || configInvalidated || win['ga-disable-' + MEASUREMENT] === true || !EVENTS.includes(name) || status.events_queued + pendingEvents.length >= 500) return false;
      var payload = Object.assign({ ga_event_name: name, consent_epoch: epoch }, context());
      if (items) {
        if (!items.length || items.length > 100) return false;
        var cleaned = items.map(item);
        if (cleaned.some(function (entry) { return !entry; })) return false;
        payload.ecommerce = {
          currency: currency || config.currency,
          value: Math.round(cleaned.reduce(function (sum, entry) { return sum + entry.price * entry.quantity; }, 0) * 100) / 100,
          items: cleaned
        };
        if (extras && extras.item_list_id) payload.ecommerce.item_list_id = text(extras.item_list_id);
        if (extras && extras.item_list_name) payload.ecommerce.item_list_name = text(extras.item_list_name);
      }
      if (!tagReady() || pendingEvents.length) {
        if (pendingEvents.length >= 100) { status.last_skip = 'pending_event_limit'; return false; }
        pendingEvents.push(payload); status.pending_events = pendingEvents.length;
        return true;
      }
      var delivered = deliver(payload);
      if (delivered) void refreshIdentity();
      return delivered;
    }
    async function readCart() {
      if (!identityCurrent() || typeof win.fetch !== 'function') return null;
      var controller = new win.AbortController();
      var timer = win.setTimeout(function () { controller.abort(); }, 2500);
      try {
        var response = await win.fetch(cartUrl.href, { method: 'GET', credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) return null;
        return cartSnapshot(await response.json());
      } catch (_) { return null; }
      finally { win.clearTimeout(timer); }
    }
    function enqueueCart(compare, showCart) {
      var generation = identityGeneration;
      chain = chain.then(async function () {
        if (!identityCurrent() || generation !== identityGeneration) return;
        var snapshot = await readCart();
        if (!identityCurrent() || generation !== identityGeneration) return;
        if (!snapshot) { baseline = null; status.last_skip = 'cart_snapshot_unavailable'; return; }
        if (compare && baseline) {
          var ambiguous = Array.from(aggregate(baseline.items).values()).concat(Array.from(aggregate(snapshot.items).values())).some(function (entry) { return entry.ambiguous_price; });
          if (ambiguous) status.last_skip = 'cart_variant_price_ambiguous';
          cartDiff(baseline, snapshot).forEach(function (event) { emit(event.name, event.items, null, snapshot.currency); });
        }
        baseline = snapshot;
        if (showCart && snapshot.items.length) emit('view_cart', snapshot.items, null, snapshot.currency);
      }).catch(function () { baseline = null; status.last_skip = 'cart_adapter_error'; });
      return chain;
    }
    function onCartUpdate(payload) {
      // Dawn publish awaits its subscribers: NEVER return our network promise.
      try {
        if (!identityCurrent() || !payload || !payload.cartData || payload.cartData.errors || payload.cartData.status) return;
        if (now() - lastCartRead < 150) { baseline = null; status.last_skip = 'cart_updates_coalesced'; return; }
        lastCartRead = now();
        void enqueueCart(true, false);
      } catch (_) { status.last_skip = 'cart_callback_error'; }
    }
    function attachDawn(attempt) {
      if (status.cart_adapter || attempt >= 15) return;
      try {
        var bus = options.dawnBus ? options.dawnBus() :
          (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' ? { subscribe: subscribe, event: PUB_SUB_EVENTS.cartUpdate } : null);
        if (bus && typeof bus.subscribe === 'function' && typeof bus.event === 'string') {
          unsubscribed = bus.subscribe(bus.event, onCartUpdate);
          status.cart_adapter = true;
          return;
        }
      } catch (_) { status.last_skip = 'dawn_adapter_unavailable'; }
      win.setTimeout(function () { attachDawn(attempt + 1); }, 300);
    }
    function setupCollection() {
      if (config.page_type !== 'collection' || typeof win.IntersectionObserver !== 'function') return;
      var grid = doc.getElementById('product-grid');
      if (!grid || !Array.isArray(config.collection_items)) return;
      var candidates = new Map();
      config.collection_items.slice(0, 48).forEach(function (raw) {
        var entry = item(raw);
        if (!entry) return;
        try { candidates.set(new URL(raw.url, win.location.origin).pathname, entry); } catch (_) { /* Skip unknown cards. */ }
      });
      var cards = new Map();
      Array.from(grid.querySelectorAll('a[href]')).forEach(function (anchor) {
        var entry;
        try { entry = candidates.get(new URL(anchor.href, win.location.origin).pathname); } catch (_) { return; }
        var card = anchor.closest('.grid__item');
        if (entry && card) cards.set(card, entry);
      });
      var list = { item_list_id: String(config.collection_id || ''), item_list_name: config.collection_name || '' };
      collectionObserver = new win.IntersectionObserver(function (entries) {
        if (!current()) return;
        var visible = [];
        entries.forEach(function (record) {
          var entry = cards.get(record.target);
          if (!entry || !record.isIntersecting || record.intersectionRatio < 0.5 || seenCollection.has(entry.item_id)) return;
          seenCollection.add(entry.item_id); visible.push(entry);
        });
        if (visible.length) emit('view_item_list', visible, list);
      }, { threshold: 0.5 });
      cards.forEach(function (_, card) { collectionObserver.observe(card); });
      grid.addEventListener('click', function (event) {
        if (!current() || event.isTrusted !== true || !event.target || typeof event.target.closest !== 'function') return;
        var anchor = event.target.closest('a[href]');
        if (!anchor || !grid.contains(anchor)) return;
        var entry;
        try { entry = candidates.get(new URL(anchor.href, win.location.origin).pathname); } catch (_) { return; }
        if (entry) emit('select_item', [entry], list);
      });
    }
    function setupDrawer() {
      var drawer = doc.querySelector('cart-drawer');
      if (!drawer || typeof win.MutationObserver !== 'function') return;
      new win.MutationObserver(function () {
        var visible = drawer.classList.contains('active') && drawer.getClientRects().length > 0;
        if (visible && !cartVisible && current()) void enqueueCart(false, true);
        cartVisible = visible;
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'hidden', 'aria-hidden'] });
    }
    function startTag() {
      if (initiallyDisabled || ((mode === 'native_inherit' || mode === 'formal_pixel_parity') &&
          win['ga-disable-' + MEASUREMENT] === true)) {
        status.measurement_allowed = false; status.state = 'test_explicitly_disabled'; return;
      }
      if (!layer) {
        if (win[LAYER] !== undefined && !Array.isArray(win[LAYER])) { status.last_skip = 'data_layer_collision'; return; }
        layer = win[LAYER] = win[LAYER] || [];
      }
      if (configInvalidated) {
        status.reload_required = true; status.state = 'reload_required_for_config';
        return; // Do not repeat config, reuse an unconfirmed config, or accept old callbacks.
      }
      if (mode === 'strict') win['ga-disable-' + MEASUREMENT] = false;
      status.measurement_allowed = current();
      if (!started) {
        started = true; configEpoch = epoch; status.config_epoch = configEpoch;
        // A second gtm.js message can retrigger production All Pages tags.
        if (!layer.some(function (entry) { return entry && entry.event === 'gtm.js'; })) {
          layer.push({ 'gtm.start': now(), event: 'gtm.js' });
        }
        pushTest('yarbo_test_ready', Object.assign({ runtime_version: VERSION, measurement_mode: mode, config_epoch: configEpoch, consent_epoch: configEpoch }, context()));
        var script = doc.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtm.js?id=' + CONTAINER;
        script.id = 'yarbo-ga4-test-gtm';
        script.onerror = function () { status.last_skip = 'gtm_load_failed'; };
        doc.head.appendChild(script);
        status.gtm_requested = true;
        setupCollection(); setupDrawer(); attachDawn(0);
      }
      status.google_tag_ready = configured;
      status.state = configured ? 'test_tag_configured' : 'waiting_for_tag_config';
      if (!initialPageSent && !pendingEvents.some(function (entry) { return entry.ga_event_name === 'page_view'; })) emit('page_view');
      if (!initialProductSent && !pendingEvents.some(function (entry) { return entry.ga_event_name === 'view_item'; }) && config.page_type === 'product' && item(config.product)) emit('view_item', [config.product]);
      if (identityCurrent()) {
        void enqueueCart(false, config.page_type === 'cart');
        if (configured) scheduleIdentity(epoch);
      }
    }
    function refreshConsent() {
      var next = privacyAllows(), changed = next !== allowed;
      if (changed) {
        allowed = next; epoch += 1; invalidateIdentity();
        pendingEvents = []; status.pending_events = 0;
        if (!allowed && mode !== 'formal_pixel_parity') clearBridge();
      }
      status.consent_epoch = epoch;
      status.analytics_allowed = allowed;
      status.identity_allowed = identityCurrent();
      if (mode === 'native_inherit' || mode === 'formal_pixel_parity') {
        // Parity mode mirrors a Shopify pixel configured as Not required. It
        // observes consent for audit but does not use it as a collection gate.
        if (!started || changed) startTag();
        status.measurement_allowed = current();
        if (configured && !allowed && current()) status.state = mode === 'formal_pixel_parity' ?
          'test_tag_configured_not_required' : 'test_tag_configured_native_no_identity';
        return;
      }
      if (!changed) {
        if (!next && win.Shopify && win.Shopify.customerPrivacy && status.state === 'waiting_for_privacy') status.state = 'blocked_by_privacy';
        return;
      }
      if (allowed) startTag();
      else {
        if (started && !configured) configInvalidated = true;
        status.google_tag_ready = false;
        win['ga-disable-' + MEASUREMENT] = true;
        status.state = 'blocked_by_privacy';
      }
      status.measurement_allowed = current();
      status.identity_allowed = identityCurrent();
    }
    function loadPrivacy(attempt) {
      if (win.Shopify && win.Shopify.customerPrivacy) { refreshConsent(); return; }
      if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
        try { win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) refreshConsent(); }); }
        catch (_) { status.last_skip = 'privacy_api_unavailable'; }
      } else if (attempt < 15) win.setTimeout(function () { loadPrivacy(attempt + 1); }, 300);
    }
    doc.addEventListener('visitorConsentCollected', refreshConsent);
    // Re-check at interactions, not by writing Shopify or global Google consent state.
    doc.addEventListener('visibilitychange', function () { refreshConsent(); if (doc.visibilityState === 'visible') void refreshIdentity(); });
    doc.addEventListener('click', function () { refreshConsent(); void refreshIdentity(); }, { capture: true, passive: true });
    clearBridge(); // Do not trust a bridge left by the unconfirmed v1 initialization.
    if (mode === 'native_inherit' || mode === 'formal_pixel_parity') startTag();
    loadPrivacy(0);
    return { status: status, emit: emit, refreshConsent: refreshConsent, refreshIdentity: refreshIdentity, onCartUpdate: onCartUpdate, drained: function () { return chain; } };
  }
  return { VERSION: VERSION, DEPLOYMENT_MODE: DEPLOYMENT_MODE, MEASUREMENT: MEASUREMENT, CONTAINER: CONTAINER, LAYER: LAYER, READY_CALLBACK: READY_CALLBACK, EVENTS: EVENTS, cleanUrl: cleanUrl, item: item, cartSnapshot: cartSnapshot, cartDiff: cartDiff, validIdentity: validIdentity, validSessionNumber: validSessionNumber, validUserId: validUserId, install: install };
});
